import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_pinterest"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12} fill="#bd081c" r={12} />
      <path
        d="M12.336 5c-3.822 0-5.754 2.744-5.754 5.025a3.065 3.065 0 001.652 3.066.279.279 0 00.407-.2l.154-.644a.373.373 0 00-.113-.448 2.341 2.341 0 01-.532-1.582 3.812 3.812 0 013.961-3.849 3.009 3.009 0 013.346 3.08c0 2.323-1.022 4.283-2.547 4.283a1.253 1.253 0 01-1.273-1.554 17.616 17.616 0 00.713-2.856 1.081 1.081 0 00-1.092-1.2c-.854 0-1.553.881-1.553 2.071a2.954 2.954 0 00.266 1.274l-1.038 4.383a9.389 9.389 0 00-.027 3.065.109.109 0 00.2.042 8.737 8.737 0 001.457-2.631l.561-2.212a2.3 2.3 0 001.959 1.008c2.59 0 4.34-2.366 4.34-5.516A4.8 4.8 0 0012.336 5z"
        fill="#fff"
      />
    </svg>
  );
}
